export const environment = {
  apiPaginationLimit: 100,
  production: false,
  apiUrl: 'https://dome-auctions-apim.azure-api.net/notaris-acc',
  apiToken: 'fabe5709fcd248e589fb0c3df9af3fea',
  msalConfig: {
    clientId: 'ace96226-b2a5-4cc2-9a90-e827459f1f5c',
    authority: 'https://domeauctionsb2b.ciamlogin.com/',
  },
};
